/* SAP product-tabs Results panel: before/after static pairs + quote carousel.
 *
 * Before/after pairs are static side-by-side tiles (no drag interaction).
 * Carousel: prev/next toggle .is-active across [data-ba-quote] figures.
 * Idempotent per element (data-wired) — section can re-render in the editor.
 * Inline JS is forbidden in section files (SAP rule). All JS lives here.
 */
(function () {
  'use strict';

  function init(root) {
    // Synced carousel: arrows advance the before/after SLIDE and the testimonial
    // together — index N shows pair N + quote N. Counts may differ; each clamps to
    // its own last item so a shorter list just holds on its final entry.
    root.querySelectorAll('[data-ba-sync]').forEach(function (scope) {
      if (scope.dataset.wired) return;
      scope.dataset.wired = '1';
      var slides = scope.querySelectorAll('[data-ba-slide]');
      var quotes = scope.querySelectorAll('[data-ba-quote]');
      var n = Math.max(slides.length, quotes.length);
      if (n < 2) return;
      var idx = 0;
      function show(k) {
        idx = (k + n) % n;
        var si = Math.min(idx, slides.length - 1);
        var qi = Math.min(idx, quotes.length - 1);
        slides.forEach(function (el, i) { el.classList.toggle('is-active', i === si); });
        quotes.forEach(function (el, i) { el.classList.toggle('is-active', i === qi); });
      }
      var prev = scope.querySelector('[data-ba-prev]');
      var next = scope.querySelector('[data-ba-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
    });

    // Ingredient carousel (mobile): arrows scroll the scroll-snap track one card at
    // a time. The track is native-scrollable/swipeable; arrows are a convenience.
    root.querySelectorAll('[data-ing-carousel]').forEach(function (c) {
      if (c.dataset.ingWired) return;
      c.dataset.ingWired = '1';
      var track = c.querySelector('[data-ing-track]');
      var prev = c.querySelector('[data-ing-prev]');
      var next = c.querySelector('[data-ing-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.sap-pt__ing-card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(sync);
      }, { passive: true });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
})();
